import { IVideoClip, VideoEditConfig } from '@packages/global';

export interface SubtitleEntry {
  index: number;
  startTime: string;
  endTime: string;
  text: string;
}

export class SRTGenerator {
  /**
   * 生成 SRT 字幕文件内容
   */
  static generateSRT(videoClips: IVideoClip[], editConfig: VideoEditConfig): string {
    const subtitleEntries: SubtitleEntry[] = [];
    let currentTime = 0;

    for (let i = 0; i < videoClips.length; i++) {
      const clip = videoClips[i];
      const clipConfig = editConfig.clips.find(c => c.clipId === clip.id);
      
      // 跳过没有脚本文字的片段
      if (!clip.script || !clip.script.trim()) {
        if (clipConfig) {
          currentTime += clipConfig.duration;
        }
        continue;
      }

      const duration = clipConfig?.duration || 3; // 默认3秒
      const startTime = this.formatTime(currentTime);
      const endTime = this.formatTime(currentTime + duration);

      subtitleEntries.push({
        index: subtitleEntries.length + 1,
        startTime,
        endTime,
        text: clip.script.trim()
      });

      currentTime += duration;
    }

    return this.formatSRT(subtitleEntries);
  }

  /**
   * 将秒数转换为 SRT 时间格式 (HH:MM:SS,mmm)
   */
  private static formatTime(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    const milliseconds = Math.floor((seconds % 1) * 1000);

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')},${milliseconds.toString().padStart(3, '0')}`;
  }

  /**
   * 格式化为 SRT 文件内容
   */
  private static formatSRT(entries: SubtitleEntry[]): string {
    return entries
      .map(entry => 
        `${entry.index}\n${entry.startTime} --> ${entry.endTime}\n${entry.text}\n`
      )
      .join('\n');
  }
}